import React, { Component } from "react";
import "./button.css";
import "./navbar.css";

class GetStartedBtn extends Component {
  render() {
    return <button className={this.props.btn}> Get Started</button>;
  }
}

export default GetStartedBtn;
